import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const DropdownStyles = styled.section`
  ${props => props.dropdownStyles};
`

class AloDropdown extends React.Component {
  constructor (props) {
    super(props)
    this.scrollToDropdown = this.scrollToDropdown.bind(this)
  }

  scrollToDropdown () {
    let dropdownElem = this.dropdown
    let dropdownVerticalPos = dropdownElem.getBoundingClientRect().top
    if (
      this.props.autoScroll &&
      !this.props.open &&
      dropdownVerticalPos !== 0
    ) {
      window.scrollTo({
        top: dropdownVerticalPos,
        behavior: 'smooth'
      })
    }
  }

  toggleDropdown () {
    this.scrollToDropdown()
    this.props.onToggle()
  }

  render () {
    let arrow
    if (this.props.open) {
      arrow = <i className='fa fa-angle-up' />
    } else {
      arrow = <i className='fa fa-angle-down' />
    }

    let title = (
      <span>
        {this.props.title}
        {arrow}
      </span>
    )

    let baseClass = ['dropdown']
    if (this.props.additionalClasses) {
      baseClass = baseClass.concat(this.props.additionalClasses)
    }

    let dropdownClass = classNames(baseClass, {
      [`open ${this.props.additionalOpenClass}`]: this.props.open
    })

    let dropdownArrowButton
    if (this.props.includeArrowButton) {
      dropdownArrowButton = (
        <button onClick={this.toggleDropdown.bind(this)}>{title}</button>
      )
    }

    return (
      <DropdownStyles dropdownStyles={this.props.dropdownStyles}>
        <div
          className={dropdownClass}
          id={this.props.id}
          ref={node => {
            this.dropdown = node
          }}
        >
          {dropdownArrowButton}
          <ul className='dropdown-menu'>{this.props.children}</ul>
        </div>
      </DropdownStyles>
    )
  }
}

AloDropdown.defaultProps = {
  includeArrowButton: true
}

AloDropdown.propTypes = {
  additionalOpenClass: PropTypes.string,
  additionalClasses: PropTypes.array,
  autoScroll: PropTypes.bool,
  children: PropTypes.node,
  dropdownStyles: PropTypes.string,
  id: PropTypes.string,
  includeArrowButton: PropTypes.bool,
  onToggle: PropTypes.func,
  open: PropTypes.bool,
  title: PropTypes.string
}

export default AloDropdown
